module.exports = __webpack_public_path__ + "images/Chatbot_eb8e822.svg";